import React, { Component } from 'react';
import {localization} from '../../Frames/localization'

import {messageWindow} from '../../Elements/Snackbar/MessageWindow'
import MessageWindow from '../../Elements/Snackbar/MessageWindow'

import {materialThemeField} from '../../../src/App'
import { ThemeProvider } from "@material-ui/styles";


import Paper from '@material-ui/core/Paper';
import InputText from "../../Elements/TextField/InputText";
import Button from "../../Elements/Button/buttons";
import Label from "../../Elements/Label/labels";
import Grid from '@material-ui/core/Grid';
import Select from '../../Elements/Select/selectCard'

//showPassword
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

class ChangePass extends Component
{
    constructor (props) {
        super(props);
        this.state = {
          oldpassword: '',
          password: '',
          confirmPassword: '',
          minCount: '',
          maxCount: '',
          typePass:'',
          showPassword: {
            oldpassword: false, 
            password: false, 
            confirmPassword: false
          },

          formErrors: {password: '',oldpassword: '', confirmPassword: '',passwordSymbols: ''},
          emailValid: false,
          passwordValid: false,
          formValid: false
        }
        this.onSubmit = this.onSubmit.bind(this);
      }
      componentDidMount()
      {
          this.setState({
              minCount: this.props.result.data.minCount,
              maxCount: this.props.result.data.maxCount,
              typePass: this.props.result.data.typePass
        })
      }
      handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value},
                      () => { this.validateField(name) });
      }
      onSubmit(event)
      {
        event.preventDefault();
        if(this.state.password !== this.state.confirmPassword)
        {
          messageWindow.OpenMessage("error", localization.GetTranslate('Security.notConfirmPass'))
          this.setState({key: Math.random()})
          return;
        }
        this.props.asyncDisabledTrue();
        var data = {
            oldpassword: this.state.oldpassword,
            password: this.state.password, 
            changepass: false
        }
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        fetch(`/alterPasswordClient`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                this.props.asyncDisabledFalse();
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.error)
            {
                this.props.asyncDisabledFalse();
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({key: Math.random()})
            }else if(response.data)
            {
                this.props.asyncDisabledFalse();
                this.setState({password: '', oldpassword: '', confirmPassword: ''})
                messageWindow.OpenMessage("success", localization.GetTranslate(response.data))
                this.setState({key: Math.random()})
            }           
        })
        
      }
      validateField(fieldName) {
        const {password, oldpassword, confirmPassword} = this.state;
        let fieldValidationErrors = this.state.formErrors;
        let passwordValid = false;
        let passwordValidCount = false;
        let passwordValidText = false;
    
            switch(this.state.typePass)
            {
                case 0:
                {
                    if(password.match(/[0-9]/)){ 
                        passwordValidText = true; 
                    }else{ 
                        passwordValidText = false; 
                    }
                    if(password.match(/[A-Za-zА-Яа-яі]/)){ 
                        passwordValidText = false; 
                    }else{ 
                        passwordValidText = true; 
                    }
                    
                    fieldValidationErrors.passwordSymbols = passwordValidText ? "": localization.GetTranslate('Security.enterErrorNumber');
                    break;
                }
                case 1:
                {
                    if(password.match(/[A-Za-zА-Яа-яі]/)){ 
                        passwordValidText = true; 
                    }else{ 
                        passwordValidText = false; 
                    }
                    if(password.match(/[0-9]/)){ 
                        passwordValidText = false; 
                    }else{ 
                        passwordValidText = true; 
                    }
                    fieldValidationErrors.passwordSymbols = passwordValidText ? "": localization.GetTranslate('Security.enterErrorChar');
                    break;
                }
                case 2:
                {
                    if(password.match(/[A-Za-zА-Яа-яі]/) && password.match(/[0-9]/)){ 
                        passwordValidText = true; 
                    }else{ 
                        passwordValidText = false; 
                    }
                    fieldValidationErrors.passwordSymbols = passwordValidText ? "": localization.GetTranslate('Security.enterErrorNumberAndChar');
                    break;
                }
                default: break;
            }
            passwordValidCount = password.length >= this.state.minCount & password.length <= this.state.maxCount;
            fieldValidationErrors.password = passwordValidCount ? "": 
            localization.GetTranslate('Security.lengthError') + this.state.minCount + localization.GetTranslate('Security.to') + this.state.maxCount + localization.GetTranslate('Security.symbols');
                    
            if(oldpassword < 1)
            {
              fieldValidationErrors.oldpassword = localization.GetTranslate('Security.enterOldPass');
            }else
            {
              fieldValidationErrors.oldpassword = '';
            }
            if(confirmPassword < 1)
            {
              fieldValidationErrors.confirmPassword = localization.GetTranslate('Security.enterConfirmPass');;
            }else
            {
              fieldValidationErrors.confirmPassword = '';
            }


        if(passwordValidCount == true && passwordValidText == true && oldpassword.length > 0 && confirmPassword.length > 0)
        {
            passwordValid = true;
        }
        this.setState({formErrors: fieldValidationErrors,
                        passwordValid: passwordValid
                      }, this.validateForm);
      }
      validateForm() {
        this.setState({formValid: this.state.passwordValid});
      }
      handleClickShowPassword = (name) => {
        const {showPassword} = this.state;
        showPassword[name] = !showPassword[name];
        this.setState({ showPassword: showPassword });
      };
    
      handleMouseDownPassword = event => {
        event.preventDefault();
      };
    render()
    {
        var tr = {
            Oldpass: localization.GetTranslate('Security.Oldpass'),
            Newpass: localization.GetTranslate('Security.New password'),
            Confirmpass: localization.GetTranslate('Security.Confirm new password'),
            Change: localization.GetTranslate('buttons.Change'),
        }

        return(
            <Paper className="ChangePassBox">
                <MessageWindow key={this.state.key} ></MessageWindow> 
                <form onSubmit={this.onSubmit}>
                    <InputText id="oldpassword"
                        label={tr.Oldpass}
                        name="oldpassword"
                        type={this.state.showPassword.oldpassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle oldpassword visibility"
                                onClick={() => this.handleClickShowPassword("oldpassword")}
                                onMouseDown={this.handleMouseDownPassword}
                              >
                                {this.state.showPassword.oldpassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        value={this.state.oldpassword}
                        onChange={this.handleUserInput}
                        error={this.state.formErrors.oldpassword}
                        autoComplete="current-oldpassword"
                        margin="normal"
                        variant="outlined"
                        className="PassField"
                        classNamelabel="PassFieldlabel"
                        required={true}/>
                    <InputText id="password"
                        label={tr.Newpass}
                        name="password"
                        type={this.state.showPassword.password ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => this.handleClickShowPassword("password")}
                                onMouseDown={this.handleMouseDownPassword}
                              >
                                {this.state.showPassword.password ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        value={this.state.password}
                        onChange={this.handleUserInput}
                        error={this.state.formErrors.password || this.state.formErrors.passwordSymbols}
                        autoComplete="current-password"
                        margin="normal"
                        variant="outlined"
                        className="PassField"
                        classNamelabel="PassFieldlabel"
                        required={true}/>
                    <InputText id="confirmPassword"
                        label={tr.Confirmpass}
                        name="confirmPassword"
                        type={this.state.showPassword.confirmPassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle confirmPassword visibility"
                                onClick={() => this.handleClickShowPassword("confirmPassword")}
                                onMouseDown={this.handleMouseDownPassword}
                              >
                                {this.state.showPassword.confirmPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        value={this.state.confirmPassword}
                        onChange={this.handleUserInput}
                        error={this.state.formErrors.confirmPassword}
                        autoComplete="current-confirmPassword"
                        margin="normal"
                        variant="outlined"
                        className="PassField"
                        classNamelabel="PassFieldlabel"
                        required={true}/>
                      {this.state.formErrors.passwordSymbols.length > 0 &&
                    <Grid container justify="center" spacing={3}>
                    <Grid item xs={"auto"}>
                        <Label textLabel={this.state.formErrors.passwordSymbols} className="SecurityErrorLabel"></Label>
                    </Grid>
                    </Grid>
                    }
                    {this.state.formErrors.password.length > 0 &&
                    <Grid container justify="center" spacing={3}>
                      <Grid item xs={"auto"}>
                          <Label textLabel={this.state.formErrors.password} className="SecurityErrorLabel"></Label>
                      </Grid>
                    </Grid>
                    }
                    {this.state.formErrors.oldpassword.length > 0 &&
                    <Grid container justify="center" spacing={3}>
                      <Grid item xs={"auto"}>
                          <Label textLabel={this.state.formErrors.oldpassword} className="SecurityErrorLabel"></Label>
                      </Grid>
                    </Grid>
                    
                    }
                    {this.state.formErrors.confirmPassword.length > 0 &&
                    <Grid container justify="center" spacing={3}>
                      <Grid item xs={"auto"}>
                          <Label textLabel={this.state.formErrors.confirmPassword} className="SecurityErrorLabel"></Label>
                      </Grid>
                    </Grid>
                    }
                    <Button
                        disabled={!this.state.formValid | this.props.asyncDisabled}
                        variant="contained"
                        type="submit"
                        value="submit"
                        color="primary"
                        textLabel={tr.Change}
                        className="buttonPass"
                    >
                    </Button>  
                    
                </form>
                
            </Paper>
        );
    }
}
class PINblock extends Component
{
    constructor (props) {
        super(props);
        this.state = {
          oldPIN: '',
          newPIN: '',

          invalidFormPIN1: false,
          invalidFormPIN2: false,

          pin: null,
          showPin1: false,
          showPin2: false,
        }
        this.onChangeOldPIN = this.onChangeOldPIN.bind(this);
        this.onChangeNewPIN = this.onChangeNewPIN.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
      }
      onChangeOldPIN(event){
        this.setState({oldPIN: event.target.value});
      }
  
      onChangeNewPIN(event) {
        this.setState({newPIN: event.target.value});
      }
      componentDidMount()
      {
          this.setState({pin: this.props.result.data.res.card.pin})
      }
    onSubmit(event)
    {
        var form = document.getElementById('FormSecurity');
        var fields = form.getElementsByTagName("input")
        for(var j=0; j<fields.length; j++)
        {
            if (fields[j].getAttribute("aria-invalid") == "true")
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('Profile.Invalid Field'))
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
                event.preventDefault();
                return;
            }
        }

        this.props.asyncDisabledTrue();
        var data = {
                oldPin: this.state.oldPIN,
                newPin: this.state.newPIN,
                cardCode: this.props.result.data.res.card.externalCode
        }
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        fetch(`/alterPin`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                this.props.asyncDisabledFalse();
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.error)
            {
                this.props.asyncDisabledFalse();
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({key: Math.random()})
            }else if(response.data)
            {
                this.props.asyncDisabledFalse();
                this.setState({oldPIN: '',newPIN: ''})
                messageWindow.OpenMessage("success", localization.GetTranslate(response.data))
                this.setState({key: Math.random()})
            }           
        })
        event.preventDefault();
    }
      handleClickShowPin1 = (event) => {
        this.setState({ showPin1: !this.state.showPin1});
      };
      handleMouseDownPin1 = event => {
        event.preventDefault();
      };
      handleClickShowPin2 = (event) => {
        this.setState({ showPin2: !this.state.showPin2 });
      };
      handleMouseDownPin2 = event => {
        event.preventDefault();
      };
      validatePinOld(value)
      {
        if(value.match(/[A-Za-zА-Яа-яі]/)){ 
            this.state.invalidFormPIN1 = true
            return true; 
        }else{ 
            this.state.invalidFormPIN1 = false
            return false; 
        }
        
      }
      validatePinNew(value)
      {
        if(value.match(/[A-Za-zА-Яа-яі]/)){ 
            this.state.invalidFormPIN2 = true
            return true; 
        }else{ 
            this.state.invalidFormPIN2 = false
            return false; 
        }
        
      }
    render()
    {
        var tr = {
            Card: localization.GetTranslate('Security.Card'),
            oldPIN: localization.GetTranslate('Security.Old PIN'),
            NewPIN: localization.GetTranslate('Security.New PIN'),
            Change: localization.GetTranslate('buttons.Change'),
            blocked: localization.GetTranslate('buttons.Blocked'),
            unblocked: localization.GetTranslate('buttons.UnBlocked'),
            cardUnBlocked: localization.GetTranslate('Security.cardUnBlocked'),
            cardBlocked: localization.GetTranslate('Security.cardBlocked'),
            cardIssued: localization.GetTranslate('Security.cardIssued'),
        }
        const{res} = this.props.result.data;
        const{AppliedSettings} = this.props;
        var dataSelect = res.cards;
        var barcode = res.card.externalCode;
        var cardActivate = res.card.status;
        var pin = res.card.pin;
        var enablePinUpdate = AppliedSettings.security_change_card_pin;
        return(
            <Paper className="PINblockBox">
                <MessageWindow key={this.state.key} ></MessageWindow> 
                <ThemeProvider theme={materialThemeField}>
                     <Select dataSelect={dataSelect} value={barcode} variant="outlined" textLabel={tr.Card} onSelectCard={this.props.onSelectCard} className="PassFieldSelect" classNameLabel="PassFieldSelectLabel"></Select>
                </ThemeProvider>
                {AppliedSettings.security_view_card_status &&
                <div>
                {cardActivate == 1 &&
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={"auto"}>
                    <Label style={{color: "green", fontWeight: "bold"}} textLabel={tr.cardUnBlocked}></Label>   
                    </Grid>
                </Grid> 
                }
                  {cardActivate == 2 &&
                  <Grid container justify="center" spacing={3}>
                      <Grid item xs={"auto"}>
                      <Label style={{color: "red", fontWeight: "bold"}} textLabel={tr.cardBlocked}></Label>   
                      </Grid>
                  </Grid> 
                  }
                  {cardActivate == 3 &&
                  <Grid container justify="center" spacing={3}>
                      <Grid item xs={"auto"}>
                      <Label style={{color: "blue", fontWeight: "bold"}} textLabel={tr.cardIssued}></Label>   
                      </Grid>
                  </Grid> 
                  }
                  </div>
                }
                {AppliedSettings.security_change_card_block &&
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={"auto"}>
                    <Button
                        onClick={this.props.onSubmitBlock}
                        disabled={this.props.asyncDisabled}
                        variant="contained"
                        type="submit"
                        value="submit"
                        textLabel={cardActivate == 2 ? tr.unblocked : tr.blocked}
                        className="buttonPass"
                    >
                    </Button>
                    </Grid>
                </Grid>
                }
                {enablePinUpdate &&
                <form id="FormSecurity" onSubmit={this.onSubmit}>
                { pin &&
                <InputText id="pinOld"
                        error={this.validatePinOld(this.state.oldPIN)}
                        label={tr.oldPIN}
                        onChange={this.onChangeOldPIN}
                        value={this.state.oldPIN}
                        name="pin"
                        type={this.state.showPin1 ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={this.handleClickShowPin1}
                                onMouseDown={this.handleMouseDownPin1}
                              >
                                {this.state.showPin1 ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        autoComplete="current-password"
                        margin="normal"
                        variant="outlined"
                        className="PassField"
                        classNamelabel="PassFieldlabel"
                        required={true}/> 
                } 
                <InputText id="pinNew"
                        error={this.validatePinNew(this.state.newPIN)}
                        label={tr.NewPIN}
                        onChange={this.onChangeNewPIN}
                        value={this.state.newPIN}
                        name="pin"
                        type={this.state.showPin2 ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={this.handleClickShowPin2}
                                onMouseDown={this.handleMouseDownPin2}
                              >
                                {this.state.showPin2 ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        autoComplete="current-password"
                        margin="normal"
                        variant="outlined"
                        className="PassField"
                        classNamelabel="PassFieldlabel"
                        required={true}/>  
                <Button
                        variant="contained"
                        type="submit"
                        value="submit"
                        color="primary"
                        textLabel={tr.Change}
                        className="buttonPass"
                        disabled={this.props.asyncDisabled | this.state.invalidFormPIN1 | this.state.invalidFormPIN2}
                    >
                </Button> 
                </form> 
                }
            </Paper>
        );
    }
}
export {ChangePass,PINblock};